// Create an input counter that displays etc. 45/100 characters
// this component should only contain the counter and not the input field
import React from 'react';
interface InputCounterProps {
	value: number;
	maxLength: number;
}

export const InputCounter: React.FC<InputCounterProps> = ({ value, maxLength }) => {
	return (
		<div style={{ display: 'flex', alignItems: 'center' }}>
			<span style={{ marginLeft: '8px', fontSize: '12px', color: '#888' }}>{`${value}/${maxLength}`}</span>
		</div>
	);
};
